module.exports = __webpack_public_path__ + "img/ic_kuajingpai_logo_normal.06fe02b.png";